<template>
    <div class="mb-2">
        <div class="text-xs text-gray mb-1">{{ label }}</div>
        <div class="text-sm">{{ value }}</div>
    </div>
</template>

<script setup lang="ts">

interface Props {
    label: string,
    value: string | null
}

const { label, value } = defineProps<Props>()

</script>
